import React from 'react';
import { Dropdown } from 'react-bootstrap';
import DokumentasjonsModal from '../dokumentasjonsModal';

function DokumentasjonsDropdown(){

    return(

                <Dropdown className="profile-dropdown mt-5">
                    <Dropdown.Toggle className="profile-dropdown-button" id="dropdown-basic">
                        SERVICE-HISTORIKK
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="profile-dropdown-open">
                        <div className="row d-flex mx-0 flex-wrap justify-content-center">
                            <p className='text-center mt-3'><DokumentasjonsModal /></p>
                        </div>
                    </Dropdown.Menu>
                    </Dropdown>
    )
}

export default DokumentasjonsDropdown;